import script from "./NavView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavView.vue?vue&type=script&lang=ts&setup=true"

import "./NavView.vue?vue&type=style&index=0&id=43bdc862&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43bdc862"]])

export default __exports__